export const ADD_REPORT = 'ADD_REPORT'
export const GET_HOLIDAYS= 'GET_HOLIDAYS'
export const SET_HOLIDAYS= 'SET_HOLIDAYS'
export const COUNT_HOLIDAYS= 'COUNT_HOLIDAYS'

